import React, { Component } from 'react';
import { Popover, Typography } from '@material-ui/core';
import { InfoRounded } from '@material-ui/icons';

type Props = {
    anchorElement?: Element,
    message?: Element
    style?: any
}

type State = {
    defaultAnchor: Element | null,
    open: boolean
}

class InfoPopover extends Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            defaultAnchor: null,
            open: false
        }
    }

    renderContent = () => {
        if (this.props.children)
            return <span>{this.props.children}</span>
        else
            return (
                <Typography variant="body1">
                    {this.props.message}
                </Typography>
            )
    }

    render() {
        return (
            <span style={{position: 'relative'}}>
                <InfoRounded {...this.props} style={{cursor:'pointer', transform: 'translateY(25%)'}} onClick={(e) => { this.setState({ defaultAnchor: e.currentTarget, open: true  }); } } />

                {(this.props.anchorElement || this.state.defaultAnchor) &&
                    <Popover
                        id={"fee-pop"}
                        anchorEl={this.props.anchorElement || this.state.defaultAnchor}
                        open={this.state.open}
                        onClose={() => this.setState({ open: false })}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                    >
                        <div style={{ maxWidth: '300px', padding: '10px' }}>
                            {this.renderContent()}
                        </div>
                    </Popover>
                }
            </span>
        );
    }
}

export default InfoPopover;